export const SIZE = 20

export const ID = 'extra'

export const NAMESPACES = [
  'layer',
  'laptop-2',
  'shield',
  'grear',
  'clock',
  'map-pin',
  'alert-triangle',
  'email-tick',
  'mobile-phone',
  'qr-code',
  'key-round',
  'case-sensitive',
  'pin-loader',
  'circular-cross',
  'personal-key',
  'exit-door',
  'password-check',
  'lark'
] as const

export type Namespaces = (typeof NAMESPACES)[number]
